import { render, staticRenderFns } from "./EditBudget.vue?vue&type=template&id=66b5f66b"
import script from "./EditBudget.vue?vue&type=script&lang=js"
export * from "./EditBudget.vue?vue&type=script&lang=js"
import style0 from "./EditBudget.vue?vue&type=style&index=0&id=66b5f66b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports